import React, { useRef, useCallback } from "react";

import "./TickerBanner.scss";
import { createTradingViewSymbolMap } from "../FinanceUtils";
import { withDefaults } from "../../../utils/withDefaults";
import { useAppSelector } from "../../../hooks";

export interface TickerBannerProps {
  widget_id?: string;
}

export default function TickerBanner(incomingProps: TickerBannerProps) {
  const props = withDefaults(incomingProps, tickerBannerDefaultProps);

  const tickerBanners = useAppSelector(state => state.layouts.tickerBanners);

  const tickerBanner = tickerBanners
    ? tickerBanners.find(banner => banner.widget_id === props.widget_id)
    : null;
  const id = "tradingview-widget-container__widget".concat(props.widget_id);

  const tickerWidgetRef = useRef<HTMLDivElement | null>(null);
  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        const element = document.getElementById(id);
        const firstChild = element?.firstChild;
        if (element && firstChild) {
          element.removeChild(firstChild);
        }
        const script = document.createElement("script");
        script.src =
          "https://s3.tradingview.com/external-embedding/embed-widget-tickers.js";
        script.async = true;

        const symbols = tickerBanner
          ? createTradingViewSymbolMap(tickerBanner.symbols, "proName", "title")
          : [
              {
                proName: "FOREXCOM:SPXUSD",
                title: "S&P 500"
              },
              {
                proName: "FOREXCOM:NSXUSD",
                title: "Nasdaq 100"
              },
              {
                proName: "FX_IDC:EURUSD",
                title: "EUR/USD"
              },
              {
                proName: "BITSTAMP:BTCUSD",
                title: "BTC/USD"
              },
              {
                proName: "BITSTAMP:ETHUSD",
                title: "ETH/USD"
              }
            ];
        script.innerHTML = `{
        "symbols": ${JSON.stringify(symbols)},
        "colorTheme": "light",
        "isTransparent": false,
        "displayMode": "regular",
        "locale": "en"
      }`;

        node.appendChild(script);
      }

      tickerWidgetRef.current = node;
    },
    [tickerBanner, id]
  );

  return (
    <div className="tradingview-widget-container">
      <div
        id={id}
        className="tradingview-widget-container__widget"
        ref={setRef}
      ></div>
      <div className="tradingview-widget-copyright">
        <a
          href="https://www.tradingview.com"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="blue-text">Quotes</span>
        </a>{" "}
        by TradingView
      </div>
    </div>
  );
}

const tickerBannerDefaultProps = {
  widget_id: ""
};
